var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_230:1051)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9419 12.1067C14.9419 11.5928 15.353 11.1817 15.867 11.1817C16.3809 11.1817 16.7921 11.5928 16.7921 12.1067C16.7921 12.6206 16.3809 13.0317 15.867 13.0317C15.353 13.0317 14.9419 12.6035 14.9419 12.1067Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5266 14.3508C20.4923 14.642 20.4581 14.9332 20.3724 15.2073C20.1154 16.1837 19.5501 17.0744 18.625 17.5712C17.3573 18.2221 15.8497 17.9823 14.582 17.4855C13.537 18.2221 13.537 18.2221 13.537 18.2221C13.2971 18.3763 12.9888 18.1193 13.1258 17.8624C12.8346 17.9138 12.7489 17.6397 12.8346 17.417C12.5948 17.6055 12.3892 17.2629 12.5262 17.0573C12.6119 16.9203 12.7489 16.7661 12.8517 16.6462C11.3784 15.8068 10.0422 14.7791 8.68881 13.7684C9.45972 14.2481 12.5434 15.824 13.2971 16.1494C14.0852 16.492 14.8732 16.8346 15.6955 17.0231C16.3808 17.1772 17.2545 17.2629 17.8884 16.8689C18.4708 16.5263 18.6935 15.824 18.7792 15.1902C18.9848 13.8198 18.5051 12.2782 17.7856 11.1133C17.0318 9.89714 15.7983 8.80085 14.3936 8.44113C13.8796 8.30409 13.3657 8.30409 12.886 8.38974C11.7725 8.57816 10.7617 9.26335 9.99079 10.1198C8.87726 11.3532 8.10634 12.8777 7.40396 14.3851C6.92428 15.3957 6.25616 17.8624 4.68007 16.886C3.97769 16.4406 3.53227 15.6698 3.22391 14.9161C2.88128 14.111 2.64144 13.0319 2.86415 12.1582C3.34383 10.3254 5.91353 11.9527 6.78723 12.5351C6.73584 12.518 4.68007 11.5758 3.92629 12.3124C3.58367 12.655 3.6008 13.2717 3.65219 13.717C3.75498 14.5221 4.149 15.7212 4.90278 16.1666C5.87927 16.7318 6.37608 14.9675 6.63305 14.3508C7.06133 13.3059 7.47248 12.261 7.95216 11.2333C8.48323 10.1027 9.11709 8.98927 9.99079 8.08141C9.80235 7.85872 9.52825 7.58465 9.51112 7.29345C9.47685 6.96798 9.80235 6.60826 10.145 6.77956C9.75095 6.33419 10.282 5.66613 10.796 5.92308C10.5561 5.54623 10.933 5.0666 11.327 5.08373C11.5497 5.08373 11.7725 5.27215 11.9438 5.39206C12.3892 5.68326 12.8346 5.9916 13.2971 6.2828C17.5629 5.61475 20.9035 10.4624 20.5266 14.3508Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_230:1051",
    x1: -8.9407e-8,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171753"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogo);
export default __webpack_public_path__ + "static/media/blue-logo.5783233c.svg";
export { ForwardRef as ReactComponent };